var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from "react";
import { useDispatch } from "react-redux";
import LikertScale from "likert-react";
import { Button, CircularProgress, Grid, TextField, Typography } from "@material-ui/core";
import MarkdownText from "../MarkdownText";
import PeerReviewOption from "./PeerReviewOption";
import * as peerReviewsActions from "../../state/peerReviews/actions";
import { useTypedSelector } from "../../state/store";
import { SpaciousTypography, StyledButton, RedButton } from "../styleComponents";
import styled from "styled-components";
var BoldTypography = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var TopMarginDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 15px;\n"], ["\n  margin-top: 15px;\n"])));

var PeerReviewForm = function PeerReviewForm(_a) {
  var languageInfo = _a.languageInfo;
  var answersToReview = useTypedSelector(function (state) {
    return state.peerReviews.options;
  });
  var peerReview = useTypedSelector(function (state) {
    return state.peerReviews.answer;
  });

  if (!answersToReview) {
    return React.createElement(Grid, {
      container: true
    }, React.createElement(Grid, {
      item: true,
      xs: 1
    }, React.createElement(CircularProgress, {
      size: 25
    })), React.createElement(Grid, {
      item: true
    }, React.createElement(Typography, null, languageInfo.loadingLabel)));
  }

  if (answersToReview.length === 0) {
    return React.createElement(Typography, null, languageInfo.noPeerAnswersAvailableLabel);
  }

  var chosenStyle = {
    fontSize: "1.5rem",
    fontStyle: "bold"
  };

  if (peerReview) {
    var chosenAnswer = answersToReview.find(function (a) {
      return a.id === peerReview.quizAnswerId;
    });

    if (!chosenAnswer) {
      return React.createElement("div", null, "Chosen answer id doesn't belong to any of the options");
    }

    return React.createElement(React.Fragment, null, React.createElement(Typography, {
      variant: "subtitle1",
      style: chosenStyle
    }, languageInfo.chosenEssayInstruction), React.createElement(PeerReviewOption, {
      answer: chosenAnswer
    }), React.createElement(PeerReviewQuestions, {
      peerReview: peerReview,
      languageInfo: languageInfo
    }));
  }

  return React.createElement(React.Fragment, null, React.createElement(Typography, {
    variant: "subtitle1",
    style: chosenStyle
  }, languageInfo.chooseEssayInstruction), answersToReview.map(function (answer, idx) {
    return React.createElement(TopMarginDiv, {
      key: answer.id
    }, React.createElement(Typography, {
      variant: "subtitle1"
    }, languageInfo.optionLabel + " " + (idx + 1) + ":"), React.createElement(PeerReviewOption, {
      answer: answer
    }), React.createElement(UnselectedPeerAnswerActions, {
      answer: answer,
      languageInfo: languageInfo
    }));
  }));
};

var PeerReviewQuestions = function PeerReviewQuestions(_a) {
  var peerReview = _a.peerReview,
      languageInfo = _a.languageInfo;
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var submitDisabled = useTypedSelector(function (state) {
    return state.peerReviews.submitDisabled;
  });
  var dispatch = useDispatch();

  if (!quiz) {
    return React.createElement("div", null);
  }

  var peerReviewQuestions = quiz.peerReviewCollections;

  var changeInPeerReviewGrade = function changeInPeerReviewGrade(peerReviewQuestionId) {
    return function (name, value) {
      dispatch(peerReviewsActions.changeGrade(peerReviewQuestionId, Number(value)));
    };
  };

  var changeInPeerReviewText = function changeInPeerReviewText(peerReviewQuestionId) {
    return function (e) {
      dispatch(peerReviewsActions.changeText(peerReviewQuestionId, e.currentTarget.value));
    };
  };

  var submitPeerReview = function submitPeerReview() {
    dispatch(peerReviewsActions.submit());
  };

  return React.createElement("div", null, peerReviewQuestions[0].questions.map(function (question) {
    var currentPeerReviewAnswer = peerReview.answers.find(function (answer) {
      return answer.peerReviewQuestionId === question.id;
    });

    if (!currentPeerReviewAnswer) {
      return React.createElement("div", null);
    }

    switch (question.type) {
      case "essay":
        currentPeerReviewAnswer = currentPeerReviewAnswer;
        return React.createElement(TextualPeerReviewFeedback, {
          handleTextChange: changeInPeerReviewText(question.id),
          key: question.id,
          currentText: currentPeerReviewAnswer.text,
          questionTexts: question.texts[0]
        });
        break;

      case "grade":
        currentPeerReviewAnswer = currentPeerReviewAnswer;
        return React.createElement(LikertScale, {
          key: question.id,
          reviews: [{
            question: question.texts[0].title,
            review: currentPeerReviewAnswer.value
          }],
          onClick: changeInPeerReviewGrade(question.id)
        });

      default:
        return React.createElement(SpaciousTypography, null, "The " + question.type + " type peer review question is not supported");
    }
  }), React.createElement(StyledButton, {
    variant: "contained",
    color: "primary",
    disabled: submitDisabled,
    onClick: submitPeerReview
  }, languageInfo.submitPeerReviewLabel));
};

var StyledReviewEssayQuestion = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 8px 0;\n"], ["\n  margin: 8px 0;\n"])));

var TextualPeerReviewFeedback = function TextualPeerReviewFeedback(_a) {
  var currentText = _a.currentText,
      handleTextChange = _a.handleTextChange,
      questionTexts = _a.questionTexts;
  var languages = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });

  if (!languages) {
    return React.createElement("div", null);
  }

  return React.createElement(StyledReviewEssayQuestion, null, React.createElement(MarkdownText, {
    Component: BoldTypography,
    variant: "subtitle1"
  }, questionTexts.title), questionTexts.body && React.createElement(MarkdownText, {
    Component: Typography,
    variant: "body1"
  }, questionTexts.body), React.createElement(TextField, {
    variant: "outlined",
    label: languages.peerReviews.essayQuestionAnswerTextBoxLabel,
    value: currentText,
    onChange: handleTextChange,
    fullWidth: true,
    multiline: true,
    rows: 5,
    margin: "normal"
  }));
};

var UnselectedPeerAnswerActions = function UnselectedPeerAnswerActions(_a) {
  var languageInfo = _a.languageInfo,
      answer = _a.answer;

  var _b = React.useState(false),
      disabled = _b[0],
      setDisabled = _b[1];

  var dispatch = useDispatch();

  var flagAsSpam = function flagAsSpam() {
    setDisabled(true);
    dispatch(peerReviewsActions.postSpam(answer.id));
  };

  var selectAnswer = function selectAnswer() {
    dispatch(peerReviewsActions.selectAnswerToReview(answer.id));
  };

  return React.createElement(Grid, {
    container: true,
    justify: "space-between"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(RedButton, {
    variant: "contained",
    disabled: disabled,
    onClick: flagAsSpam
  }, languageInfo.reportAsInappropriateLabel)), React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: selectAnswer
  }, languageInfo.chooseButtonLabel)));
};

export default PeerReviewForm;
var templateObject_1, templateObject_2, templateObject_3;